// extracted by mini-css-extract-plugin
module.exports = {"item":"AdminLink_item__RuNhz","activeItem":"AdminLink_activeItem__nKlPw","visibleItem":"AdminLink_visibleItem__UGbZL"};